import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Row } from "react-bootstrap";
import Select from "react-select";
import moment from "moment";
import { ROOM_CATEGORY } from "constant/constants";
import services from "../../API/services";
import { authenticationSeletor } from "../../store/slices/authenticationSlice";
import Layout from "../../layout";
import ModalQuickSoldOut from './ModalQuickSoldOut'
import ModalBulkUpdate from './ModalBulkUpdate';
import { toast } from 'react-toastify';
import { useBlockedNavigation } from "./useUnsavedChangesGuard";
import { useBeforeUnload } from "react-router-dom";
import { getTaxService } from "API/services/newServices";
import axios from 'axios';
import { mainUrl } from 'API/client/api';
import { createPropertyLogs } from 'store/slices/PropertyData';

const timeZone = [
    "00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"
]

const RoomRateManager = () => {
    const dispatch = useDispatch();
    const { userDetail } = useSelector(authenticationSeletor);
    const [pageLoading, setPageLoading] = useState(true)
    const [rooms, setRooms] = useState([]);
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [tax, setTax] = useState({});
    const [showQuick, setShowQuick] = useState(false);
    const [showBulk, setShowBulk] = useState(false);
    const [currentCategory, setCurrentCategory] = useState({});
    const [checkedState, setCheckedState] = useState({});
    const [priceState, setPriceState] = useState({});
    const [timeState, setTimeState] = useState({});
    const [selectedDates, setSelectedDates] = useState([]);
    const [finalPayload, setFinalPayload] = useState();
    const [isDirty, setIsDirty] = useState(false);
    const [showPrompt, setShowPrompt] = useState(false);
    const [pendingBlocker, setPendingBlocker] = useState(null);
    const [resumeNavigation, setResumeNavigation] = useState(null);
    const [allowHourly, setAllowHourly] = useState(0);
    const [hotelInfo, setHotelInfo] = useState({});
    const [roomInfo, setRoomInfo] = useState([]);
    const [dirtyData, setDirtyData] = useState([]);
    const [propertiesList, setPropertiesList] = useState([]);
    const [selectedCate, setSelectedCate] = useState(null);

    const options = propertiesList?.map((item) => { return { value: item?.id, label: item?.name, code: item?.propertyCode } })

    const [logData, setLogData] = useState([]);

    const fetchProperties = async () => {
        try {
            const res = await services.property.propertyListService();
            if (res.data.status == true) { setPropertiesList(res?.data?.data) }
        }
        catch (err) { console.log(err) }
    }

    useEffect(() => { fetchProperties(); }, [])

    const safeParse = (value) => {
        try {
            if (!value) return {};
            if (typeof value === "object") return value;
            if (typeof value === "string") return JSON.parse(value);
            return {};
        } catch (e) {
            console.error("Parse error:", value);
            return {};
        }
    };

    const getTaxApi = async () => {
        try {
            const res = await getTaxService();
            if (res) { setTax(res); }
        } catch (error) { console.error("Parse error:"); }
    };

    useEffect(() => { getTaxApi(); }, [])

    const handleStatusChange = (date, value, showUpdateButton = true) => {
        if (showUpdateButton) { setIsDirty(true); }
        const statusVal = value;
        setSelectedDates((prev) => {
            const arr = Array.isArray(prev) ? prev : [];
            if (statusVal == "Available") { return arr.filter((d) => d.date !== date); }
            else {
                const exists = arr.find((d) => d.date === date);
                if (exists) { return arr.map((d) => d.date == date ? { ...d, soldOut: true } : d); }
                else { return [...arr, { date, soldOut: true }]; }
            }
        });
        setCheckedState((prev) => {
            const slots = ["FullDay", "3Hrs", "6Hrs", "9Hrs"];
            const updatedSlots = slots?.map((slot) => ({
                slot,
                status: statusVal,
            }));
            return {
                ...prev,
                [date]: updatedSlots,
            };
        });
        setLogData(prev => updateLogData(prev, date, 'stop', value, 'Sell'));
    };

    useEffect(() => {
        if (Array.isArray(selectedDates)) {
            selectedDates.forEach(item => {
                handleStatusChange(
                    item.date,
                    item.soldOut ? "Sold-Out" : "Available",
                    false
                );
            });
        }
    }, [showQuick]);

    const getDataHandler = async () => {
        const fd = fromDate ? `&fromDate=${fromDate?.toISOString().substring(0, 10)}  00:00:00` : "";
        const td = toDate ? `&toDate=${toDate?.toISOString().substring(0, 10)}  00:00:00` : "";
        try {
            const res = await services.property.getRroomsPropertyByFilter(`/${userDetail?.propertyId || selectedCate?.value}?${fd}${td}`);
            setHotelInfo({ locationId: res.data.data.locationId, authCode: res.data.data.AuthCode })
            setRooms(res.data.data.Rooms);
            setAllowHourly(res?.data?.data?.allowHourly)
        } catch (error) { console.error("Parse error:"); }
        finally { setPageLoading(false) }
    };

    useMemo(() => { getDataHandler(); }, [fromDate, toDate, selectedCate]);

    useEffect(() => { if (rooms.length > 0) { setCurrentCategory(rooms[0]); } }, [rooms]);

    let allDates = [];
    const totalDays = 10;
    const today = new Date();
    for (let i = 0; i < totalDays; i++) {
        const nextDate = new Date(today);
        nextDate.setDate(today.getDate() + i);
        allDates.push(nextDate);
    }

    const updateLogData = (prev, date, slot, value, type) => {
        const formattedDate = moment(date).format('YYYY-MM-DD');
        const existingIndex = prev.findIndex(item => item.date === formattedDate && item.categoryId == currentCategory?.categoryId);
        if (existingIndex != -1) {
            const updated = [...prev];
            updated[existingIndex] = {
                ...updated[existingIndex],
                [`${slot}${type}`]: value,
            };
            return updated;
        }
        else { return [...prev, { date: formattedDate, categoryId: currentCategory?.categoryId, [`${slot}${type}`]: value }]; }
    };

    const handlePriceChange = (date, slot, value) => {
        let newObj = { date: date, slot: slot, value: value }
        let exitDate = dirtyData?.some((item) => item.date == date)
        if (slot == "FullDay") {
            if (exitDate) {
                let exitPrice = dirtyData?.find((item) => item.date == date)
                exitPrice.value = value
            }
            else { setDirtyData([...dirtyData, newObj]) }
        }
        setLogData(prev => updateLogData(prev, date, slot, value, 'Price'));
        setIsDirty(true);
        const dateKey = moment(date).format("YYYY-MM-DD");
        setPriceState((prev) => {
            const existingSlots = [...(prev[dateKey] || [])];
            const slotIndex = existingSlots.findIndex((s) => s.slot == slot);
            let updatedSlots;
            if (slotIndex > -1) {
                updatedSlots = existingSlots.map((s, idx) =>
                    idx == slotIndex ? { ...s, price: value } : s
                );
            }
            else { updatedSlots = [...existingSlots, { slot, price: value }]; }
            return { ...prev, [dateKey]: updatedSlots };
        });
    };

    const handleTimeChange = (date, slot, type, value) => {
        setIsDirty(true);
        const dateKey = moment(date).format("YYYY-MM-DD");
        setTimeState((prev) => {
            const existingSlots = [...(prev[dateKey] || [])];
            const slotIndex = existingSlots.findIndex((s) => s.slot == slot);
            let updatedSlots;
            if (slotIndex > -1) {
                updatedSlots = existingSlots.map((s, idx) =>
                    idx == slotIndex ? { ...s, [type]: value } : s
                );
            }
            else { updatedSlots = [...existingSlots, { slot, [type]: value }]; }
            return { ...prev, [dateKey]: updatedSlots };
        });
        setLogData(prev => updateLogData(prev, date, slot, value, `${type}Time`));
    };

    const segregateBySlot = (data, slotName) => {
        const result = {};
        Object.entries(data || {}).forEach(([date, arr]) => {
            if (Array.isArray(arr)) {
                const filtered = arr.filter((item) => item?.slot == slotName);
                if (filtered.length > 0) { result[date] = filtered; }
            }
            else { console.warn(`Expected array for date ${date}, got:`, arr); }
        });
        return result;
    };

    const mergeStates = (...objs) => {
        const merged = {};
        objs.forEach(obj => { Object.entries(obj || {}).forEach(([date, slots]) => { merged[date] = [...(merged[date] || []), ...slots]; }); });
        return merged;
    };

    useEffect(() => {
        if (currentCategory) {
            // ✅ Status segregation
            const fullDayStatus = segregateBySlot(safeParse(currentCategory?.fullDayStatus), "FullDay");
            const threeHrStatus = segregateBySlot(safeParse(currentCategory?.threeHrStatus), "3Hrs");
            const sixHrStatus = segregateBySlot(safeParse(currentCategory?.sixHrStatus), "6Hrs");
            const nineHrStatus = segregateBySlot(safeParse(currentCategory?.nineHrStatus), "9Hrs");
            // ✅ Offer Price segregation
            const offerPrice = safeParse(currentCategory?.offerPrice);
            const threeHrOfferPrice = segregateBySlot(offerPrice, "3Hrs");
            const sixHrOfferPrice = segregateBySlot(offerPrice, "6Hrs");
            const nineHrOfferPrice = segregateBySlot(offerPrice, "9Hrs");
            const fullDayOfferPrice = segregateBySlot(offerPrice, "FullDay");
            // ✅ CheckIn segregation
            const threeHrCheckIn = segregateBySlot(safeParse(currentCategory?.threeHrCheckIn), "3Hrs");
            const sixHrCheckIn = segregateBySlot(safeParse(currentCategory?.sixHrCheckIn), "6Hrs");
            const nineHrCheckIn = segregateBySlot(safeParse(currentCategory?.nineHrCheckIn), "9Hrs");
            // Status
            const safeStatus = safeParse(currentCategory?.status);
            // ✅ Final payload
            const payload = {
                fullDayStatus,
                threeHrStatus,
                sixHrStatus,
                nineHrStatus,
                offerPrice,
                threeHrOfferPrice,
                sixHrOfferPrice,
                nineHrOfferPrice,
                fullDayOfferPrice,
                threeHrCheckIn,
                sixHrCheckIn,
                nineHrCheckIn,
            };
            // ✅ Bind data to UI states (properly merged)
            setSelectedDates(safeStatus)
            setCheckedState(mergeStates(fullDayStatus, threeHrStatus, sixHrStatus, nineHrStatus));
            setPriceState(mergeStates(fullDayOfferPrice, threeHrOfferPrice, sixHrOfferPrice, nineHrOfferPrice));
            setTimeState(mergeStates(threeHrCheckIn, sixHrCheckIn, nineHrCheckIn));
            setFinalPayload(payload);
        }
    }, [currentCategory, showQuick, showBulk]);

    const saveDataHandler = async (id, showToast = true) => {
        try {
            const payload = {
                fullDayStatus: checkedState,
                threeHrStatus: checkedState,
                sixHrStatus: checkedState,
                nineHrStatus: checkedState,
                offerPrice: priceState,
                threeHrOfferPrice: priceState,
                sixHrOfferPrice: priceState,
                nineHrOfferPrice: priceState,
                threeHrCheckIn: timeState,
                sixHrCheckIn: timeState,
                nineHrCheckIn: timeState,
                status: selectedDates
            };
            let res = await services.property.updateRoomPrice(payload, id);
            if (res.data.status == true) {
                if (!showBulk && !showQuick) {
                    const params = {
                        action: `Room Tarrif`,
                        actionBy: userDetail?.firstName + ' ' + userDetail?.lastName,
                        operation: JSON.stringify(logData),
                        propertyId: userDetail?.propertyId
                    }
                    dispatch(createPropertyLogs(params))
                }
                handleThirdPartyRoomRateAPI()
                getDataHandler();
                if (showToast) { toast.success("Room data updated successfully!"); }
                setIsDirty(false);
                setShowPrompt(false)
            }
        } catch (err) { toast.error("Failed to update room data!"); }
    };

    const handleQuickSoldOut = async (ids) => {
        try {
            await Promise.all(ids.map((id, index) => saveDataHandler(id, false)));
            toast.success("Room data updated successfully!");
        } catch (err) { toast.error("Failed to update room data!"); }
    };

    const handleCheckboxChange = (date, slot, status) => {
        setIsDirty(true);
        const dateKey = moment(date).format("YYYY-MM-DD");
        setCheckedState((prev) => {
            const existingSlots = [...(prev[dateKey] || [])];
            const slotIndex = existingSlots.findIndex((s) => s.slot == slot);
            let updatedSlots;
            if (slotIndex > -1) {
                updatedSlots = existingSlots.map((s, idx) =>
                    idx == slotIndex
                        ? { ...s, status: s.status === "Available" ? "Sold-Out" : "Available" }
                        : s
                );
            }
            else { updatedSlots = [...existingSlots, { slot, status: "Sold-Out" }]; }
            const newState = { ...prev, [dateKey]: updatedSlots };
            return newState;
        });
        setLogData(prev => updateLogData(prev, date, slot, status, 'Status'));
    };

    const blockReload = isDirty;

    // declare once, outside component OR above useEffect
    const handleBeforeUnload = (e) => {
        e.preventDefault();
        setShowPrompt(true);
    };

    const handleKeyDown = (e) => {
        if ((e.ctrlKey && e.key === "r") || e.key === "F5") {
            e.preventDefault();
            setShowPrompt(true);
        }
    };

    useEffect(() => {
        if (!blockReload) return;
        window.addEventListener("beforeunload", handleBeforeUnload);
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [blockReload]);

    const discardChanges = () => {
        setIsDirty(false);
        setShowPrompt(false);
        window.removeEventListener("beforeunload", handleBeforeUnload);
        document.removeEventListener("keydown", handleKeyDown);
        window.location.reload();
    };

    useBlockedNavigation(
        isDirty,
        useCallback((proceed) => {
            setResumeNavigation(() => proceed);
            setShowPrompt(true);
        }, [])
    );

    const fetchRoomInformation = async () => {
        const payload = {
            RES_Request: {
                Request_Type: "RoomInfo",
                NeedPhysicalRooms: 1,
                Authentication: {
                    HotelCode: hotelInfo?.locationId,
                    AuthCode: hotelInfo?.authCode
                }
            }
        }
        try {
            const res = await axios.post(`${mainUrl}api/proxy`, payload);
            if (res) { setRoomInfo(res.data.data.RoomInfo.RatePlans.RatePlan) }
        }
        catch (err) { console.log('Error:', err.response ? err.response.data : err.message) }
    }

    useEffect(() => { if (hotelInfo) { fetchRoomInformation() } }, [hotelInfo])

    const updateLinearRate = async (RoomTypeID, RateTypeID) => {
        let payload = {
            RES_Request: {
                Request_Type: "UpdateRoomRates",
                Authentication: {
                    HotelCode: hotelInfo?.locationId,
                    AuthCode: hotelInfo?.authCode
                },
                RateType: dirtyData?.map((data) => ({
                    RoomTypeID: RoomTypeID,
                    RateTypeID: RateTypeID,
                    FromDate: moment(data?.date).format('YYYY-MM-DD'),
                    ToDate: moment(data?.date).format('YYYY-MM-DD'),
                    RoomRate: {
                        Base: data?.value
                    }
                }))
            }
        }
        const res = await axios.post(`${mainUrl}api/update-room-rate`, payload);
    }

    const handleThirdPartyRoomRateAPI = () => {
        let cateId = currentCategory?.categoryId
        const RoomsCategoryId = currentCategory?.categoryId == 1 ? "STANDARD DOUBLE BED"
            : cateId == 2 ? "DELUXE ROOM"
                : cateId == 3 ? "SUITE ROOM"
                    : cateId == 5 ? "STANDARD SINGLE BED"
                        : cateId == 6 ? "STANDARD TWIN BED"
                            : cateId == 7 ? "DELUXE TWIN BED"
                                : cateId == 9 ? "FAMILY ROOM"
                                    : cateId == 10 ? "PREMIUM ROOM"
                                        : "STANDARD DOUBLE BED";
        const dataToBeSend = roomInfo?.find(
            (item) => item?.RoomType?.toUpperCase() == RoomsCategoryId?.toUpperCase()
        );
        if (dataToBeSend) { updateLinearRate(dataToBeSend?.RoomTypeID, dataToBeSend?.RateTypeID)}
    }
    
    const rroomsUser = userDetail?.logintype == "rroomUser"
    const propertyUser = userDetail?.logintype == "propertyUser"

    return (
        <Layout title="Room Price Settings ">
            {
                rroomsUser &&
                <div className='d-flex justify-content-center'>
                    <div className='searcharea' style={{ width: '300px' }}>
                        <Select
                            value={selectedCate}
                            onChange={setSelectedCate}
                            options={options}
                            placeholder="Select a Property"
                        />
                    </div>
                </div>
            }
            {
                ((rroomsUser && selectedCate != null) || propertyUser) ?
                    pageLoading ? 'Loading...' : (
                        <Row className='price-setting'>
                            <div className="tabs">
                                <div className="tab-head flex justify-content-between">
                                    <div className='tab-primary'>
                                        <ul>
                                            {rooms?.map((item) => (
                                                <li
                                                    key={item.categoryId}
                                                    className={item?.categoryId === currentCategory?.categoryId ? 'active' : ''}
                                                    onClick={() => setCurrentCategory(item)}>
                                                    {ROOM_CATEGORY?.[item?.categoryId].toLowerCase().replace(/\b\w/g, c => c.toUpperCase())}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="right">
                                        <button type="button" className="btn btn-dark btn-sm mr-2" onClick={() => setShowQuick(true)}>Quick Stop Sell</button>
                                        <button type="button" className="btn btn-primary btn-sm" onClick={() => setShowBulk(true)}>Bulk Update</button>
                                    </div>
                                </div>
                                <div className={`tab-body border-site text-center ${allowHourly && currentCategory?.categoryId === 1 ? '' : 'roomRatePlan'}`}>
                                    <div className='flex short-day-booking head'>
                                        <div className='slot-row head'>
                                            <div className={`slot-box one`}>
                                                <h6>Booking Date</h6>
                                            </div>

                                            <div className='slot-box two'>
                                                <h6>Rate (GST Exclusive)</h6>
                                                <ul>
                                                    {
                                                        allowHourly && currentCategory?.categoryId === 1 ? (
                                                            <>
                                                                <li>3Hrs</li>
                                                                <li>6Hrs</li>
                                                                <li>9Hrs</li>
                                                            </>
                                                        ) : ''
                                                    }
                                                    <li>FullDay</li>
                                                </ul>
                                            </div>

                                            {
                                                allowHourly && currentCategory?.categoryId === 1 ? (
                                                    <div className='slot-box three three-items'>
                                                        <h6>Manage Timing (First Check in - Last Check in)</h6>
                                                        <ul>
                                                            <li>3Hrs</li>
                                                            <li>6Hrs</li>
                                                            <li>9Hrs</li>
                                                        </ul>
                                                    </div>
                                                ) : ''
                                            }



                                            {/* {currentCategory?.categoryId != 1 &&
                                        <div className='slot-box two'>
                                            <h6>Rate (GST Exclusive)</h6>
                                            <ul>
                                                <li>FullDay</li>
                                            </ul>
                                        </div>
                                    } */}
                                            <div className='slot-box four'>
                                                <h6>Stop Sell</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`flex short-day-booking ${totalDays == 4 ? 'five' : ''}`}>
                                        {allDates?.map((date, i) => {
                                            const formattedDate = moment(date).format("YYYY-MM-DD");
                                            const isSoldOut = (Array.isArray(selectedDates) ? selectedDates : [])
                                                .some(d => d.date == formattedDate && d.soldOut);
                                            return (
                                                <div className={`slot-row ${isSoldOut ? "sold-out-bg text-dark" : ""}`} key={i}>
                                                    <div className={`slot-box one`}>
                                                        <h6 className={`${isSoldOut ? "sold-out-bg border-danger" : ""}`}>
                                                            <span className="mb-2">{moment(date).format("DD-MM-YYYY")}</span>
                                                        </h6>
                                                    </div>

                                                    <div className="slot-box two">
                                                        <h6 className='for-sm'>Rate (GST Exclusive)</h6>
                                                        <div className='inner'>

                                                            {
                                                                currentCategory?.categoryId === 1 && (

                                                                    allowHourly ? (
                                                                        <>
                                                                            {
                                                                                ["3Hrs", "6Hrs", "9Hrs"].map((slot) => {
                                                                                    const baseRoom = rooms.find(cate => cate?.categoryId == 1);
                                                                                    const dateKey = formattedDate;
                                                                                    const slotObj = checkedState[dateKey]?.find((s) => s.slot === slot);
                                                                                    const status = slotObj?.status || "Available";
                                                                                    const priceVal =
                                                                                        priceState[dateKey]?.find(s => s.slot == slot)?.price ||
                                                                                        (slot === "3Hrs" && baseRoom?.threeHrPrice) ||
                                                                                        (slot === "6Hrs" && baseRoom?.sixHrPrice) ||
                                                                                        (slot === "9Hrs" && baseRoom?.nineHrPrice);
                                                                                    const checkInVal = timeState[dateKey]?.find((s) => s.slot === slot)?.checkIn || "";
                                                                                    const checkOutVal = timeState[dateKey]?.find((s) => s.slot === slot)?.checkOut || "";
                                                                                    return (
                                                                                        <>
                                                                                            <div className='box'>
                                                                                                <h6 className='head-for-sm'>{slot}</h6>
                                                                                                <input
                                                                                                    type="number"
                                                                                                    className="form-item"
                                                                                                    value={priceVal}
                                                                                                    onChange={(e) => handlePriceChange(date, slot, e.target.value)}
                                                                                                    disabled={isSoldOut}
                                                                                                />
                                                                                                <label
                                                                                                    className={`switch ${isSoldOut
                                                                                                        ? "inactive bg-danger text-white"
                                                                                                        : status == "Available"
                                                                                                            ? "active"
                                                                                                            : ""
                                                                                                        }`}
                                                                                                >
                                                                                                    <input
                                                                                                        type="checkbox"
                                                                                                        checked={isSoldOut ? true : status == "Available"}
                                                                                                        onChange={() => handleCheckboxChange(date, slot, status == "Available" ? 'Sold-Out' : 'Available')}
                                                                                                        disabled={isSoldOut}
                                                                                                    />
                                                                                                    <span className="text">{isSoldOut ? "Sold-Out" : status}</span>
                                                                                                </label>
                                                                                            </div>
                                                                                        </>
                                                                                    );
                                                                                })}
                                                                        </>
                                                                    ) : ''

                                                                )
                                                            }
                                                            <div className='box'>
                                                                <h6 className='head-for-sm'>FullDay</h6>
                                                                <input
                                                                    type="number"
                                                                    className="form-item mb-2"
                                                                    placeholder="Price"
                                                                    value={priceState[formattedDate]?.find((s) => s.slot === "FullDay")?.price || rooms.find(cate => cate?.categoryId === 1)?.regularPrice}
                                                                    onChange={(e) => handlePriceChange(formattedDate, "FullDay", e.target.value)}
                                                                    disabled={isSoldOut}
                                                                />
                                                                <div>
                                                                    {(() => {
                                                                        const dateKey = formattedDate;
                                                                        const slotObj = checkedState[dateKey]?.find((s) => s.slot == "FullDay");
                                                                        const status = slotObj?.status || "Available";
                                                                        return (
                                                                            <label
                                                                                className={`switch ${isSoldOut
                                                                                    ? "inactive bg-danger text-white"
                                                                                    : status == "Available"
                                                                                        ? "active"
                                                                                        : ""
                                                                                    }`}
                                                                            >
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={isSoldOut ? true : status == "Available"}
                                                                                    onChange={() => handleCheckboxChange(date, "FullDay", status == "Available" ? 'Sold-Out' : 'Available')}
                                                                                    disabled={isSoldOut}
                                                                                />
                                                                                <span className="text">{isSoldOut ? "Sold-Out" : status}</span>
                                                                            </label>
                                                                        );
                                                                    })()}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {
                                                        allowHourly && currentCategory?.categoryId === 1 ? (
                                                            <div className='slot-box three'>
                                                                <h6 className='for-sm'>Manage Timing (First Check in - Last Check in)</h6>
                                                                <div className='inner'>
                                                                    {
                                                                        allowHourly && (
                                                                            <>
                                                                                {
                                                                                    ["3Hrs", "6Hrs", "9Hrs"].map((slot) => {
                                                                                        const dateKey = formattedDate;
                                                                                        const slotObj = checkedState[dateKey]?.find((s) => s.slot == slot);
                                                                                        const status = slotObj?.status || "Available";
                                                                                        const priceVal = priceState[dateKey]?.find((s) => s.slot == slot)?.price || "";
                                                                                        const checkInVal = timeState[dateKey]?.find((s) => s.slot == slot)?.checkIn || "00:00";
                                                                                        const checkOutVal = timeState[dateKey]?.find((s) => s.slot == slot)?.checkOut || "23:00";
                                                                                        return (
                                                                                            <>
                                                                                                <div className='box'>
                                                                                                    <div className='mb-2'>
                                                                                                        <h6 className='head-for-sm'>{slot}</h6>
                                                                                                        <select
                                                                                                            className={isSoldOut ? "form-item sold-out-light-dark" : "form-item "}
                                                                                                            disabled={isSoldOut}
                                                                                                            value={checkInVal}
                                                                                                            onChange={(e) => handleTimeChange(date, slot, "checkIn", e.target.value)}
                                                                                                        >
                                                                                                            <option value="">Select</option>
                                                                                                            {timeZone?.map((time, i) => (
                                                                                                                <option key={i}>{time}</option>
                                                                                                            ))}
                                                                                                        </select>
                                                                                                    </div>
                                                                                                    <select
                                                                                                        className={isSoldOut ? "form-item sold-out-light-dark" : "form-item "}
                                                                                                        disabled={isSoldOut}
                                                                                                        value={checkOutVal}
                                                                                                        onChange={(e) => handleTimeChange(date, slot, "checkOut", e.target.value)}
                                                                                                    >
                                                                                                        <option value="">Select</option>
                                                                                                        {timeZone?.map((time, i) => (
                                                                                                            <option key={i}>{time}</option>
                                                                                                        ))}
                                                                                                    </select>
                                                                                                </div>
                                                                                            </>
                                                                                        );
                                                                                    })}
                                                                            </>
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>
                                                        ) : ''
                                                    }

                                                    <div className='slot-box four'>
                                                        <select
                                                            className="form-item"
                                                            value={selectedDates?.find?.((d) => d.date === formattedDate) ? "Sold-Out"
                                                                : "Available"}
                                                            onChange={(e) => handleStatusChange(formattedDate, e.target.value)}>
                                                            <option value="Available">Available</option>
                                                            <option value="Sold-Out">Sold-Out</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                            {isDirty && (
                                <div className='text-center fixed-btn mt-4'>
                                    <button type='button' className='btn btn-site'
                                        onClick={() => saveDataHandler(currentCategory?.id)}>Update</button>
                                </div>
                            )}
                        </Row>
                    ) : <div className='text-center pt-5 pb-5'>Please select a property</div>
            }
            {showPrompt && (
                <div className='confirm-modal'>
                    <p>You have unsaved changes. Would you like to save them before leaving?</p>
                    <div className='flex justify-content-center'>
                        <button type='button' className='btn btn-success' onClick={() => saveDataHandler(currentCategory?.id)}>
                            Save Changes
                        </button>
                        <button type='button' className='btn btn-danger ml-2' onClick={discardChanges}>Discard</button>
                    </div>
                </div>
            )}
            <ModalQuickSoldOut
                show={showQuick}
                hide={setShowQuick}
                selectedDates={selectedDates}
                setSelectedDates={setSelectedDates}
                setIsDirty={setIsDirty}
                rooms={rooms}
                handleQuickSoldOut={handleQuickSoldOut}
                hotelInfo={hotelInfo}
                handleStatusChange={handleStatusChange}
                userDetail={userDetail} />
            <ModalBulkUpdate
                show={showBulk}
                hide={setShowBulk}
                timeZone={timeZone}
                rooms={rooms}
                handleQuickSoldOut={handleQuickSoldOut}
                selectedDates={selectedDates}
                setSelectedDates={setSelectedDates}
                hotelInfo={hotelInfo}
                refreshData={getDataHandler}
                allowHourly={allowHourly}
                userDetail={userDetail} />
        </Layout>
    )
}

export default RoomRateManager;